import { useEffect, useState } from 'react'
import { conciergeService } from '../services/conciergeService'

/**
 * Returns whether the AI Concierge is available for an event.
 *
 * Returns false while loading and whenever either gate (global or per-event) is
 * off, so nothing flashes before the gate resolves and the widget/entry points
 * stay hidden unless the feature is truly enabled.
 */
export function useConciergeEnabled(eventId: string | undefined | null): boolean {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    let active = true
    if (!eventId) {
      setEnabled(false)
      return
    }
    conciergeService.getEventConfig(eventId).then((cfg) => {
      if (active) setEnabled(Boolean(cfg.enabled))
    })
    return () => {
      active = false
    }
  }, [eventId])

  return enabled
}
